import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const sortInternalUsersByFirstName = (users) =>
  [...users].sort((a, b) => {
    const nameA = (a.firstName || '').toLowerCase();
    const nameB = (b.firstName || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });

// Get all internal users
export const getAllInternalUsers = async () => {
  try {
    const usersCollection = collection(db, 'internal_users');
    // Equality on status only — no composite index (avoid status + orderBy firstName).
    const usersQuery = query(usersCollection, where('status', '==', 'active'));
    const usersSnapshot = await getDocs(usersQuery);

    return sortInternalUsersByFirstName(
      usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
    );
  } catch (error) {
    console.error('Error fetching internal users:', error);
    throw error;
  }
};

// Get internal users by team
export const getInternalUsersByTeam = async (team) => {
  try {
    const usersCollection = collection(db, 'internal_users');
    const usersQuery = query(
      usersCollection,
      where('status', '==', 'active'),
      where('team', '==', team)
    );
    const usersSnapshot = await getDocs(usersQuery);

    return sortInternalUsersByFirstName(
      usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
    );
  } catch (error) {
    console.error('Error fetching internal users by team:', error);
    throw error;
  }
};

// Search internal users
export const searchInternalUsers = async (searchTerm) => {
  try {
    const usersCollection = collection(db, 'internal_users');
    const usersQuery = query(usersCollection, where('status', '==', 'active'));
    const usersSnapshot = await getDocs(usersQuery);

    const term = searchTerm.toLowerCase();
    const users = sortInternalUsersByFirstName(
      usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
    );

    return users.filter(
      (user) =>
        user.firstName?.toLowerCase().includes(term) ||
        user.lastName?.toLowerCase().includes(term) ||
        user.email?.toLowerCase().includes(term)
    );
  } catch (error) {
    console.error('Error searching internal users:', error);
    throw error;
  }
};
